document.addEventListener('DOMContentLoaded', () => {
  const desktopQuery = window.matchMedia('(min-width: 990px)');

  function isDesktop() {
    return desktopQuery.matches;
  }

  function getValidHref(link) {
    const href = link.getAttribute('href');
    if (!href || href === '#') return null;
    return href;
  }

  /*
    Desktop: open dropdowns on hover by adding Dawn's required "open" attribute.
  */
  document.querySelectorAll('.header__inline-menu details').forEach((details) => {
    details.addEventListener('mouseenter', () => {
      if (!isDesktop()) return;
      details.setAttribute('open', '');
    });

    details.addEventListener('mouseleave', () => {
      if (!isDesktop()) return;
      details.removeAttribute('open');
    });
  });

  /*
    Desktop: when clicking a parent menu link, navigate instead of allowing
    Dawn's summary/details toggle to handle the click.
  */
  document.addEventListener(
    'click',
    (event) => {
      const parentLink = event.target.closest('[data-tmm-parent-menu-link]');
      if (!parentLink) return;

      const details = parentLink.closest('details');
      if (!details) return;

      const href = getValidHref(parentLink);
      if (!href) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      if (isDesktop()) {
        window.location.href = href;
        return;
      }

      /*
        Mobile behavior:
        - First tap opens the submenu.
        - Second tap goes to the parent page.
      */
      if (!details.hasAttribute('open')) {
        details.setAttribute('open', '');
        details.dataset.tmmOpenedOnce = 'true';
        return;
      }

      if (details.dataset.tmmOpenedOnce === 'true') {
        window.location.href = href;
        return;
      }

      details.dataset.tmmOpenedOnce = 'true';
    },
    true
  );
});